export default __webpack_public_path__ + "static/media/mg-icon.c88b5e7a.svg";